import _implicitStylesheets from "./metadataCardV2.css";
import _implicitScopedStylesheets from "./metadataCardV2.scoped.css?scoped=true";
import _wdsLabeledValue from "wds/labeledValue";
import _axIcon from "ax/icon";
import _wdsLink from "wds/link";
import _listingHarnessIcon from "listing/harnessIcon";
import _wdsPopoverTooltip from "wds/popoverTooltip";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span type-style="body-2"${3}>${"t1"}</span>`;
const $fragment2 = parseFragment`<dt type-style="body-2" class="metadata-label${0}"${2}>${"t1"}</dt>`;
const $fragment3 = parseFragment`<span type-style="body-2" class="rating-average${0}"${2}>${"t1"}</span>`;
const $fragment4 = parseFragment`<a${"a0:href"} class="rating-reviews-anchor${0}" data-testid="metadata-review-count-link"${2}>${"t1"}</a>`;
const $fragment5 = parseFragment`<span type-style="body-2"${3}>${"t1"}</span>`;
const $fragment6 = parseFragment`<span type-style="body-2"${3}>${"t1"}</span>`;
const $fragment7 = parseFragment`<dt type-style="body-2" class="metadata-label${0}"${2}>${"t1"}</dt>`;
const $fragment8 = parseFragment`<span class="solution-type-icon solution-type-icon--consultant${0}" aria-hidden="true"${2}></span>`;
const $fragment9 = parseFragment`<span type-style="body-2"${3}>${"t1"}</span>`;
const $fragment10 = parseFragment`<span${3}>${"t1"}</span>`;
const $fragment11 = parseFragment`<dd type-style="body-2"${3}>${"t1"}</dd>`;
const $fragment12 = parseFragment`<span${3}>${"t1"}</span>`;
const $fragment13 = parseFragment`<dd type-style="body-2"${3}>${"t1"}</dd>`;
const $fragment14 = parseFragment`<span type-style="body-2"${3}>${"t1"}</span>`;
const $fragment15 = parseFragment`<span type-style="body-2"${3}>${"t1"}</span>`;
const $fragment16 = parseFragment`<span type-style="body-2"${3}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "metadata-card": true
  },
  attrs: {
    "data-testid": "metadata-card"
  },
  key: 0
};
const stc1 = {
  classMap: {
    "metadata-section": true,
    "metadata-section--social-proof": true
  },
  key: 1
};
const stc2 = {
  "metadata-row": true
};
const stc3 = {
  "data-testid": "metadata-publisher"
};
const stc4 = {
  classMap: {
    "metadata-row": true
  },
  attrs: {
    "data-testid": "metadata-rating"
  },
  key: 5
};
const stc5 = {
  key: 8
};
const stc6 = {
  classMap: {
    "rating": true
  },
  attrs: {
    "data-testid": "metadata-rating-value"
  },
  key: 9
};
const stc7 = {
  "rating-stars": true
};
const stc8 = {
  "rating-star": true
};
const stc9 = {
  "rating-reviews-link": true
};
const stc10 = {
  classMap: {
    "metadata-section": true,
    "metadata-section--works-with": true
  },
  key: 19
};
const stc11 = {
  "data-testid": "metadata-works-with"
};
const stc12 = {
  classMap: {
    "works-with-list": true
  },
  key: 21
};
const stc13 = {
  "works-with-item": true
};
const stc14 = {
  "data-testid": "metadata-works-with-item"
};
const stc15 = {
  classMap: {
    "metadata-section": true,
    "metadata-section--history": true
  },
  key: 26
};
const stc16 = {
  classMap: {
    "metadata-row": true
  },
  attrs: {
    "data-testid": "metadata-solution-type"
  },
  key: 27
};
const stc17 = {
  classMap: {
    "solution-type-value": true
  },
  key: 30
};
const stc18 = {
  "solution-type-icon": true
};
const stc19 = {
  "solution-type-glyph-icon": true
};
const stc20 = {
  classMap: {
    "metadata-row": true
  },
  attrs: {
    "data-testid": "metadata-certifications"
  },
  key: 37
};
const stc21 = {
  classMap: {
    "metadata-label": true,
    "metadata-label--tooltip": true
  },
  attrs: {
    "type-style": "body-2"
  },
  key: 38
};
const stc22 = {
  "tooltip-container": true
};
const stc23 = {
  classMap: {
    "metadata-row": true
  },
  attrs: {
    "data-testid": "metadata-certified-people"
  },
  key: 44
};
const stc24 = {
  classMap: {
    "metadata-label": true,
    "metadata-label--tooltip": true
  },
  attrs: {
    "type-style": "body-2"
  },
  key: 45
};
const stc25 = {
  "data-testid": "metadata-version"
};
const stc26 = {
  "data-testid": "metadata-last-updated"
};
const stc27 = {
  "data-testid": "metadata-listed-on"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, k: api_key, i: api_iterator, h: api_element, b: api_bind} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", stc0, [api_element("dl", stc1, [$cmp.metadataPublisherName ? api_custom_element("wds-labeled-value", _wdsLabeledValue, {
    classMap: stc2,
    attrs: stc3,
    props: {
      "title": $cmp.i18n.listingDetails.metadata.provider
    },
    key: 2
  }, [api_static_fragment($fragment1, 4, [api_static_part(1, null, api_dynamic_text($cmp.metadataPublisherName))])]) : null, $cmp.shouldShowRating ? api_element("div", stc4, [api_static_fragment($fragment2, 7, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.metadata.rating))]), api_element("dd", stc5, [$cmp.hasRating ? api_element("div", stc6, [api_static_fragment($fragment3, 11, [api_static_part(1, null, api_dynamic_text($cmp.formattedAverageRating))]), api_element("span", {
    classMap: stc7,
    attrs: {
      "role": "img",
      "aria-label": $cmp.ratingAriaLabel
    },
    key: 12
  }, api_iterator($cmp.ratingStars, function (star) {
    return api_custom_element("ax-icon", _axIcon, {
      classMap: stc8,
      props: {
        "icon": "favorite",
        "size": "small",
        "gradient": star.gradient,
        "ariaHidden": "true"
      },
      key: api_key(13, star.id)
    });
  })), api_custom_element("wds-link", _wdsLink, {
    classMap: stc9,
    props: {
      "name": "reviews",
      "label": $cmp.reviewsCount,
      "href": $cmp.reviewsTabHref
    },
    key: 14
  }, [api_static_fragment($fragment4, 16, [api_static_part(0, {
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleReviewsLinkClick))
    },
    attrs: {
      "href": $cmp.reviewsTabHref
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.reviewsCount))])])]) : null, !$cmp.hasRating ? api_static_fragment($fragment5, 18, [api_static_part(1, null, api_dynamic_text($cmp.noRatingText))]) : null])]) : null]), $cmp.shouldShowWorksWith ? api_element("dl", stc10, [api_custom_element("wds-labeled-value", _wdsLabeledValue, {
    classMap: stc2,
    attrs: stc11,
    props: {
      "title": $cmp.i18n.listingDetails.metadata.worksWith
    },
    key: 20
  }, [api_element("ul", stc12, api_iterator($cmp.worksWithItems, function (harness) {
    return api_element("li", {
      classMap: stc13,
      attrs: stc14,
      key: api_key(22, harness.id)
    }, [api_custom_element("listing-harness-icon", _listingHarnessIcon, {
      props: {
        "installMethodId": harness.id
      },
      key: 23
    }), api_static_fragment($fragment6, 25, [api_static_part(1, null, api_dynamic_text(harness.label))])]);
  }))])]) : null, api_element("dl", stc15, [$cmp.shouldShowSolutionType ? api_element("div", stc16, [api_static_fragment($fragment7, 29, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.metadata.solutionType))]), api_element("dd", stc17, [$cmp.isConsultantListing ? api_static_fragment($fragment8, 32) : null, $cmp.shouldShowTechnologyIcon ? api_custom_element("ax-icon", _axIcon, {
    classMap: stc18,
    props: {
      "icon": $cmp.iconTechnologySymbol,
      "spriteUrl": "/images/icons.svg",
      "ariaHidden": "true"
    },
    key: 33
  }) : null, $cmp.solutionTypeGlyphIcon ? api_custom_element("ax-icon", _axIcon, {
    classMap: stc19,
    props: {
      "icon": $cmp.solutionTypeGlyphIcon,
      "ariaHidden": "true"
    },
    key: 34
  }) : null, api_static_fragment($fragment9, 36, [api_static_part(1, null, api_dynamic_text($cmp.solutionTypeLabel))])])]) : null, $cmp.shouldShowCertifications ? api_element("div", stc20, [api_element("dt", stc21, [api_static_fragment($fragment10, 40, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.certificationsLabel))]), api_custom_element("wds-popover-tooltip", _wdsPopoverTooltip, {
    classMap: stc22,
    props: {
      "tooltipData": $cmp.certificationsTooltip,
      "popoverOrientation": $cmp.consultantStatTooltipOrientation
    },
    key: 41
  })]), api_static_fragment($fragment11, 43, [api_static_part(1, null, api_dynamic_text($cmp.formattedTotalCertificationsCount))])]) : null, $cmp.shouldShowCertifiedPeople ? api_element("div", stc23, [api_element("dt", stc24, [api_static_fragment($fragment12, 47, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.certifiedPeopleLabel))]), api_custom_element("wds-popover-tooltip", _wdsPopoverTooltip, {
    classMap: stc22,
    props: {
      "tooltipData": $cmp.certifiedPeopleTooltip,
      "popoverOrientation": $cmp.consultantStatTooltipOrientation
    },
    key: 48
  })]), api_static_fragment($fragment13, 50, [api_static_part(1, null, api_dynamic_text($cmp.formattedCertifiedPeopleCount))])]) : null, $cmp.shouldShowCurrentVersion ? api_custom_element("wds-labeled-value", _wdsLabeledValue, {
    classMap: stc2,
    attrs: stc25,
    props: {
      "title": $cmp.i18n.listingDetails.metadata.currentVersion
    },
    key: 51
  }, [api_static_fragment($fragment14, 53, [api_static_part(1, null, api_dynamic_text($cmp.currentVersion))])]) : null, $cmp.shouldShowLastUpdated ? api_custom_element("wds-labeled-value", _wdsLabeledValue, {
    classMap: stc2,
    attrs: stc26,
    props: {
      "title": $cmp.i18n.listingDetails.metadata.lastUpdated
    },
    key: 54
  }, [api_static_fragment($fragment15, 56, [api_static_part(1, null, api_dynamic_text($cmp.lastUpdated))])]) : null, $cmp.shouldShowListedOn ? api_custom_element("wds-labeled-value", _wdsLabeledValue, {
    classMap: stc2,
    attrs: stc27,
    props: {
      "title": $cmp.i18n.appDetails.listedOn
    },
    key: 57
  }, [api_static_fragment($fragment16, 59, [api_static_part(1, null, api_dynamic_text($cmp.listedOn))])]) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3af8fnvno8s";
tmpl.legacyStylesheetToken = "undefined-_metadataCardV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
